import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

const SummaryStatisticsCard = ({ analytics }) => {
  const safeAnalytics = Array.isArray(analytics) ? analytics : [];

  return (
    <Card>
      <Card.Header>
        <h5>Summary Statistics</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={3}>
            <Card className="text-center">
              <Card.Body>
                <Card.Title className="text-primary">
                  {safeAnalytics.reduce((sum, item) => sum + (item.total_applications || 0), 0)}
                </Card.Title>
                <Card.Text>Total Applications</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center">
              <Card.Body>
                <Card.Title className="text-success">
                  {safeAnalytics.reduce((sum, item) => sum + (item.attended_meet_greet || 0), 0)}
                </Card.Title>
                <Card.Text>Total Attended</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center">
              <Card.Body>
                <Card.Title className="text-info">
                  {safeAnalytics.reduce((sum, item) => sum + (item.registered_startupworld || 0), 0)}
                </Card.Title>
                <Card.Text>Total Registered</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center">
              <Card.Body>
                <Card.Title className="text-warning">
                  {safeAnalytics.reduce((sum, item) => sum + (item.assigned_project || 0), 0)}
                </Card.Title>
                <Card.Text>Total Assigned</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SummaryStatisticsCard;